import React, { useEffect, useState } from "react";
import type { CollapseProps } from "antd";
import { Collapse } from "antd";
import s from "./FilterPopOver.module.scss";
import clsx from "clsx";
type PropType = {
  reportType: string;
  order: "asc" | "desc" | undefined;
  setOrder: (order: "asc" | "desc" | undefined) => void;
  messagingChannel: "sms" | "mms" | undefined;
  setMessagingChannel: (channel: "sms" | "mms" | undefined) => void;
  voiceChannel: "voice-broadcast" | "voice-message" | undefined;
  setVoiceChannel: (
    channel: "voice-broadcast" | "voice-message" | undefined
  ) => void;
  user: {
    active: boolean;
    inActive: boolean;
    newSignUps: boolean;
    highUsageAccount: boolean;
  };
  setUser: (user: {
    active: boolean;
    inActive: boolean;
    newSignUps: boolean;
    highUsageAccount: boolean;
  }) => void;
  compliance: { spam: boolean; revoked: boolean; failed: boolean };
  setCompliance: (compliance: {
    spam: boolean;
    revoked: boolean;
    failed: boolean;
  }) => void;
  financialChannel: "sms"|"mms" | "email" | "voice" | undefined;
  setFinancialChannel: (
    channel: "sms"|"mms" | "email" | "voice" | undefined
  ) => void;

  status: "failed" | "delivered" | undefined;
  setStatus: (status: "failed" | "delivered" | undefined) => void;
};
function FilterPopOverContent({
  reportType,
  financialChannel,
  messagingChannel,
  order,
  setFinancialChannel,
  setMessagingChannel,
  setOrder,
  setStatus,
  setVoiceChannel,
  status,
  voiceChannel,
  setUser,
  user,
  compliance,
  setCompliance,
}: PropType) {
  const [activeKey, setActiveKey] = useState<string>();
  const [orderDraft, setDraftOrder] = useState<"asc" | "desc">();
  const [messagingDraftChannel, setMessagingDraftChannel] = useState<
    "sms" | "mms"
  >();
  const [voiceDraftChannel, setVoiceDraftChannel] = useState<
    "voice-broadcast" | "voice-message" | undefined
  >("voice-broadcast");
  const [financialDraftChannel, setFinancialDraftChannel] = useState<
    "sms"|"mms"| "email" | "voice"
  >();
  const [userDraft, setUserDraft] = useState<{
    active: boolean;
    inActive: boolean;
    newSignUps: boolean;
    highUsageAccount: boolean;
  }>({
    active: false,
    inActive: false,
    newSignUps: false,
    highUsageAccount: false,
  });
  const [complianceDraft, setComplianceDraft] = useState<{
    spam: boolean;
    revoked: boolean;
    failed: boolean;
  }>({
    spam: false,
    revoked: false,
    failed: false,
  });
  const [statusDraft, setDraftStatus] = useState<"failed" | "delivered">();
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Order",
      children: (
        <div className={clsx(s.options, { [s.active]: activeKey === "1" })}>
          <p
            className={clsx(s.option, { [s.active]: orderDraft === "desc" })}
            onClick={() => setDraftOrder("desc")}
          >
            Latest to earliest
          </p>
          <p
            className={clsx(s.option, { [s.active]: orderDraft === "asc" })}
            onClick={() => setDraftOrder("asc")}
          >
            Earliest to latest
          </p>
        </div>
      ),
    },
    ...(reportType === "messaging"
      ? [
          {
            key: "2",
            label: "Channel",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "2" })}
              >
                <p
                  className={clsx(s.option, {
                    [s.active]: messagingDraftChannel === "sms",
                  })}
                  onClick={() => setMessagingDraftChannel("sms")}
                >
                  SMS
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: messagingDraftChannel === "mms",
                  })}
                  onClick={() => setMessagingDraftChannel("mms")}
                >
                  MMS
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(reportType === "user"
      ? [
          {
            key: "2",
            label: "User",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "2" })}
              >
                <p
                  className={clsx(s.checkboxOption, {
                    [s.active]: userDraft?.active,
                  })}
                  onClick={() =>
                    setUserDraft((prev) => ({ ...prev, active: !prev?.active }))
                  }
                >
                  Active
                </p>
                <p
                  className={clsx(s.checkboxOption, {
                    [s.active]: userDraft.inActive,
                  })}
                  onClick={() =>
                    setUserDraft((prev) => ({
                      ...prev,
                      inActive: !prev.inActive,
                    }))
                  }
                >
                  Inactive
                </p>
                <p
                  className={clsx(s.checkboxOption, {
                    [s.active]: userDraft.newSignUps,
                  })}
                  onClick={() =>
                    setUserDraft((prev) => ({
                      ...prev,
                      newSignUps: !prev.newSignUps,
                    }))
                  }
                >
                  New signups
                </p>
                <p
                  className={clsx(s.checkboxOption, {
                    [s.active]: userDraft.highUsageAccount,
                  })}
                  onClick={() =>
                    setUserDraft((prev) => ({
                      ...prev,
                      highUsageAccount: !prev.highUsageAccount,
                    }))
                  }
                >
                  New signups
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(reportType === "voice"
      ? [
          {
            key: "2",
            label: "Channel",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "2" })}
              >
                <p
                  className={clsx(s.option, {
                    [s.active]: voiceDraftChannel === "voice-broadcast",
                  })}
                  onClick={() => setVoiceDraftChannel("voice-broadcast")}
                >
                  Voice broadcast
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: voiceDraftChannel === "voice-message",
                  })}
                  onClick={() => setVoiceDraftChannel("voice-message")}
                >
                  Voice message
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(reportType === "financial"
      ? [
          {
            key: "2",
            label: "Channel",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "2" })}
              >
                <p
                  className={clsx(s.option, {
                    [s.active]: financialDraftChannel === "sms",
                  })}
                  onClick={() => setFinancialDraftChannel("sms")}
                >
                  SMS
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: financialDraftChannel === "mms",
                  })}
                  onClick={() => setFinancialDraftChannel("mms")}
                >
                  MMS
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: financialDraftChannel === "email",
                  })}
                  onClick={() => setFinancialDraftChannel("email")}
                >
                  Email
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: financialDraftChannel === "voice",
                  })}
                  onClick={() => setFinancialDraftChannel("voice")}
                >
                  Voice
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(reportType !== "financial" &&
    reportType !== "user" &&
    reportType !== "compliance"
      ? [
          {
            key: "3",
            label: "Status",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "3" })}
              >
                <p
                  className={clsx(s.option, {
                    [s.active]: statusDraft === "delivered",
                  })}
                  onClick={() => setDraftStatus("delivered")}
                >
                  Delivered
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: statusDraft === "failed",
                  })}
                  onClick={() => setDraftStatus("failed")}
                >
                  Failed
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(reportType === "compliance"
      ? [
          {
            key: "3",
            label: "Status",
            children: (
              <div
                className={clsx(s.options, { [s.active]: activeKey === "3" })}
              >
                <p
                  className={clsx(s.option, {
                    [s.active]: complianceDraft.spam,
                  })}
                  onClick={() =>
                    setComplianceDraft((prev) => ({
                      spam: !prev?.spam,
                      failed: false,
                      revoked: false,
                    }))
                  }
                >
                  Spam/Abuse
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: complianceDraft.revoked,
                  })}
                  onClick={() =>
                    setComplianceDraft((prev) => ({
                      failed: false,
                      spam: false,
                      revoked: !prev.revoked,
                    }))
                  }
                >
                  Revoked
                </p>
                <p
                  className={clsx(s.option, {
                    [s.active]: complianceDraft.failed,
                  })}
                  onClick={() =>
                    setComplianceDraft((prev) => ({
                      revoked: false,
                      spam: false,
                      failed: !prev.failed,
                    }))
                  }
                >
                  Failed KYC
                </p>
              </div>
            ),
          },
        ]
      : []),

  ];
  const onChange = (key: string | string[]) => {
    if (Array.isArray(key)) {
      // collapse closed (empty array), reset state
      setActiveKey(key[0]);
    } else {
      setActiveKey(key);
    }
  };
  const handleRest = () => {
    setOrder(undefined);
    setFinancialChannel(undefined);
    if (reportType === "messaging") {
      setMessagingChannel("sms");
      setMessagingDraftChannel("sms");
    } else {
      setMessagingChannel(undefined);
      setMessagingDraftChannel(undefined);
    }
    setStatus(undefined);
    if (reportType === "voice") {
      setVoiceChannel("voice-broadcast");
      setVoiceDraftChannel("voice-broadcast");
    } else {
      setVoiceChannel(undefined);
      setVoiceDraftChannel(undefined);
    }
    setDraftOrder(undefined);
    setFinancialDraftChannel(undefined);
    setDraftStatus(undefined);
    setComplianceDraft({
      spam: false,
      revoked: false,
      failed: false,
    });
    setCompliance({
      spam: false,
      revoked: false,
      failed: false,
    });
    if (reportType === "user") {
      setUserDraft({
        active: true,
        highUsageAccount: false,
        inActive: false,
        newSignUps: true,
      });
      setUser({
        active: true,
        highUsageAccount: false,
        inActive: false,
        newSignUps: true,
      });
    } else {
      setUserDraft({
        active: false,
        highUsageAccount: false,
        inActive: false,
        newSignUps: false,
      });
      setUser({
        active: false,
        highUsageAccount: false,
        inActive: false,
        newSignUps: false,
      });
    }
  };
  const handleApply = () => {
    setOrder(orderDraft);
    setFinancialChannel(financialDraftChannel);
    setMessagingChannel(messagingDraftChannel);
    setStatus(statusDraft);
    setVoiceChannel(voiceDraftChannel);
    setUser(userDraft);
    setCompliance(complianceDraft);
  };
  useEffect(() => {
    setDraftOrder(order);
    setFinancialDraftChannel(financialChannel);
    setDraftStatus(status);
    setMessagingDraftChannel(messagingChannel);
    setUserDraft(user);
    setVoiceDraftChannel(voiceChannel);
    setComplianceDraft(compliance);
  }, [
    compliance,
    financialChannel,
    messagingChannel,
    order,
    status,
    user,
    voiceChannel,
  ]);

  return (
    <div className={s.wrapper}>
      <Collapse items={items} accordion ghost onChange={onChange} />
      <div className={s.btnWrapper}>
        <button className={s.resetBtn} onClick={handleRest}>
          Reset
        </button>
        <button className={s.applyBtn} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
}

export default FilterPopOverContent;
